<template lang="pug">
#Home
  .welcome Bienvenido
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style lang="stylus" scoped>
.welcome
  font-size 1.4em
</style>



// WEBPACK FOOTER //
// src/components/Home.vue